import React, { Component } from 'react'
import './style.css'
import LeaveIcon from '../../assets/leave.png'
import OvertimeIcon from '../../assets/overtime.png'
import TeamIcon from '../../assets/team.png'
import TableMain from './TableMain';
import Gpass from '../../assets/gpass_icon.PNG';
import fieldpass from '../../assets/fieldpass_icon.PNG';
import Expense from '../../assets/expense_icon.PNG';
import Hexapi from '../../utility/HexAPI/Hexapi'
import Tint from '../../utility/ImageTint/Tint'
import withRouter from '../../utility/withRouter';
import Loader from '../../components/loader/Loader'


 class Approvals extends Component {
    constructor(props) {
        super(props)
        this.state = {
          
            userid: this.props.userid,
            ApprovalMenuList: [], isApprovalMenuListFound: false, isApiHitComplete: false, selectedtileapprovalsInfo: [],
            isTablesShow: false
        }

        this.getApprovalMenuList = this.getApprovalMenuList.bind(this)
        this.gettileapprovalsIcon = this.gettileapprovalsIcon.bind(this)
        this.openRespectiveTable = this.openRespectiveTable.bind(this)
        this.reloadApprovals = this.reloadApprovals.bind(this)
    }
    componentDidUpdate(prevProps) {
        if (this.props.userid !== prevProps.userid) {
            this.setState({ userid: this.props.userid }, () => {
                this.getApprovalMenuList()
            });
        }
    }
    getApprovalMenuList(isReload='0') {
        let obj = {
            'query': `HRApp_Droid_Proc_User_Approvals_MainScreen_GetList @UserID = '{0}'`,
            'queryArr': [`${this.props.userid}`]
        }
        if(isReload == '1'){
            this.setState({ isTablesShow: false})
        }
        this.setState({ isApiHitComplete: false })
        Hexapi(obj).then((resp) => {
            console.log(resp,"approvals")
            if (resp.maininfo.length > 0) {
                this.setState({
                    ApprovalMenuList: resp.maininfo,
                    isApprovalMenuListFound: true
                })
            } else {
                this.setState({
                    isApprovalMenuListFound: false
                })
            }
        }).then(() => this.setState({ isApiHitComplete: true })).catch(err => console.error(err))
    }
    gettileapprovalsIcon(item) {
        console.log(item,"apdhgfshjdbkns")
        let icon = ''
        if (item.approvaltype == "1") {
            icon = OvertimeIcon
        }
        if (item.approvaltype == "2" || item.approvaltype == "3" ) {
            icon = TeamIcon
        }
        if (item.approvaltype == "4") {
            icon = LeaveIcon
        }
        if(item.approvaltype == "5"){
            icon = Gpass
        }
        if (item.approvaltype == "6") {
            icon = Expense
        }
        if (item.approvaltype == "7") {
            icon = fieldpass
        }
        if (icon != "") {
            return icon
        }
    }
    openRespectiveTable(item) {
        this.setState({
            selectedtileapprovalsInfo: item,
            isTablesShow: true
        })
    }
    componentDidMount() {
        if(!this.props.userid) return
        this.setState({ userid: this.props.userid })
        this.getApprovalMenuList()
    }
    reloadApprovals(){
        this.getApprovalMenuList('1')
    }
    render() {
        return (
            <>
                {
                    this.state.isApiHitComplete ?
                        this.state.isApprovalMenuListFound ?
                            !this.state.isTablesShow ?
                                <div className="Approval_MainBox">
                                    {
                                        this.state.ApprovalMenuList.map((item, index) => {
                                            return (
                                                <>
                                                    <div className="tileapprovals" key={index} onClick={() => this.openRespectiveTable(item)}>
                                                        {item.totalcount > 0 ? <div className="totalCount"><span>{item.totalcount}</span></div> : ""}
                                                        <div className="icon">
                                                            <img src={this.gettileapprovalsIcon(item)} alt="" style={{ filter: Tint('#29B6F6') }} />
                                                        </div>
                                                        <span>{item.header}</span>
                                                    </div>
                                                </>
                                            )
                                        })
                                    }
                                </div>
                                :
                                <TableMain
                                    selectedtileapprovalsInfo={this.state.selectedtileapprovalsInfo}
                                    userid={this.state.userid}
                                    getPhotoUrl={this.state.getPhotoUrl}
                                    goBack={() => this.reloadApprovals()}
                                />
                            :
                            <div className="TemporaryDiv">
                                <h5 style={{ color: 'orange' }}>No Records!</h5>
                            </div>
                        :
                        <div className="TemporaryDiv">
                             <Loader/>
                        </div>
                }
            </>
        )
    }
}

export default withRouter(Approvals);